// extracted by mini-css-extract-plugin
export default {"container":"registrationProfil_container__53rcl","data":"registrationProfil_data__TJX5F"};